import { __assign } from "tslib";
import { RcClasses } from '../../../../foundation';
export var RcDraggableClasses = RcClasses(['root', 'isDragging'], 'RcDraggable');
export var getDirectionOnlyItemStyle = function (direction, style) {
    if (!direction) {
        return style;
    }
    var isVertical = direction === 'vertical';
    var overrideStyles = {};
    var currentTransformMatch = style &&
        style.transform &&
        style.transform.match(/translate\((-?\d+)px,\s+(-?\d+)px\)/);
    if (currentTransformMatch) {
        var transform = parseInt(currentTransformMatch[isVertical ? 2 : 1], 10);
        overrideStyles['transform'] = "translate(" + (isVertical ? 0 : transform) + "px, " + (isVertical ? transform : 0) + "px)";
    }
    return __assign(__assign({}, style), overrideStyles);
};
